import { useEffect } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { useTheme } from '@/contexts/ThemeContext';

/**
 * Hook to apply brand colors from tenant data to the theme
 * Should be used in a component that renders after auth is loaded
 */
export function useBrandColors() {
  const { tenant } = useAuth();
  const { applyBrandColors } = useTheme();
  
  useEffect(() => {
    if (tenant) {
      const primaryColor = tenant.primary_color;
      const secondaryColor = tenant.secondary_color;
      
      if (primaryColor || secondaryColor) {
        applyBrandColors(primaryColor, secondaryColor);
      }
    }
  }, [tenant, applyBrandColors]);
}
